var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var SessionErrorKey;
(function (SessionErrorKey) {
    // 403 Access Denied
    SessionErrorKey["ACCESS_DENIED"] = "SessionErrorAccessDenied";
    // 401 Authorization Required
    SessionErrorKey["AUTH_REQUIRED"] = "SessionErrorAuthRequired";
    // 401 Www Authentication Required
    SessionErrorKey["WWW_AUTH_REQUIRED"] = "SessionErrorWwwAuthRequired";
    // 409 Conflict
    SessionErrorKey["CONFLICT"] = "SessionErrorConflict";
    // Decode/parse error
    SessionErrorKey["DECODE"] = "SessionErrorDecode";
    // Error raised by a client's callback
    SessionErrorKey["EXTERNAL_CALLBACK_ERROR"] = "SessionErrorExternalCallbackFail";
    // 400 Bad Request
    SessionErrorKey["INPUT"] = "SessionErrorInput";
    // 412 Precondition Failed
    SessionErrorKey["PRECONDITION_FAILED"] = "SessionErrorPreconditionFailed";
    // Specialized 400 Bad Request for known errors
    SessionErrorKey["VALIDATION_ERROR"] = "SessionErrorValidation";
    // No internet/network connection
    SessionErrorKey["NETWORK"] = "SessionErrorNetwork";
    // 404 Not Found
    SessionErrorKey["NOT_FOUND"] = "SessionErrorNotFound";
    // 410 Gone - mainly used when tokens expire
    SessionErrorKey["GONE"] = "SessionErrorResourceGone";
    // 429 Too many requests - mainly thrown by brute force detection
    SessionErrorKey["TOO_MANY_REQUESTS"] = "SessionErrorTooManyRequests";
    // Some operation timed out
    SessionErrorKey["TIMEOUT"] = "SessionErrorTimeout";
    // Generic HTTP request error
    SessionErrorKey["REQUEST"] = "SessionErrorRequest";
    // 5xx Server Error
    SessionErrorKey["SERVER"] = "SessionErrorServer";
    // 502 + 503 Gateway Error + Timeout
    SessionErrorKey["SERVER_GATEWAY"] = "SessionErrorServerGateway";
    // Unknown base url
    SessionErrorKey["UNKNOWN_SERVER"] = "SessionErrorUnknownServer";
    // Malformed JWT that cannot be parsed
    SessionErrorKey["MALFORMED_JWT"] = "SessionMalformedJWT";
    // Malformed response from the server
    SessionErrorKey["MALFORMED_RESPONSE"] = "SessionErrorMalformedResponse";
    // Generic configuration error
    SessionErrorKey["IMPROPERLY_CONFIGURED"] = "SessionErrorImproperlyConfigured";
    // Missing refresh token where required
    SessionErrorKey["REFRESH_TOKEN_MISSING"] = "SessionErrorMissingRefreshToken";
    // Missing public key where required
    SessionErrorKey["PUBLIC_KEY_MISSING"] = "SessionErrorMissingPublicKey";
    // User is already logged in
    SessionErrorKey["ALREADY_LOGGED_IN"] = "SessionErrorAlreadyLoggedIn";
    // Provided auth method is not supported
    SessionErrorKey["UNKNOWN_AUTH_METHOD"] = "SessionErrorUnknownAuthMethod";
    // Provided communication channel is not supported
    SessionErrorKey["UNKNOWN_COMMUNICATION_CHANNEL"] = "SessionErrorUnknownCommunicationChannel";
    // Provided communication medium is not supported
    SessionErrorKey["UNKNOWN_COMMUNICATION_MEDIUM"] = "SessionErrorUnknownCommunicationMedium";
    // Password validation failed
    SessionErrorKey["PASSWORD_POLICY_FAILED"] = "SessionErrorPasswordPolicyFailed";
    SessionErrorKey["PASSWORD_POLICY_BLACKLIST_FAILED"] = "SessionErrorPasswordBlacklistRegexFailed";
    SessionErrorKey["PASSWORD_POLICY_HISTORY_FAILED"] = "SessionErrorPasswordPolicyHistoryFailed";
    SessionErrorKey["PASSWORD_POLICY_REGEX_FAILED"] = "SessionErrorPasswordPolicyRegexFailed";
    SessionErrorKey["PASSWORD_POLICY_MIN_LENGTH_FAILED"] = "SessionErrorPasswordMinLengthRegexFailed";
    SessionErrorKey["PASSWORD_POLICY_NOT_EMAIL_FAILED"] = "SessionErrorPasswordNotEmailRegexFailed";
    // Invalid old password in change password request
    SessionErrorKey["INVALID_OLD_PASSWORD"] = "SessionErrorInvalidOldPassword";
    // Token refresh after user update failed. The user needs to relog.
    // We throw a special error to allow better error handling on clients.
    SessionErrorKey["REFRESH_AFTER_UPDATE_ERROR"] = "SessionErrorRefreshAfterUpdateFail";
    // Trying to set a unique resource which is already in use
    SessionErrorKey["ALREADY_IN_USE"] = "SessionErrorAlreadyInUse";
    // Login otp operation data is missing or it is invalid
    SessionErrorKey["INVALID_OTP_LOGIN_OPERATION"] = "SessionErrorInvalidOtpLoginOperation";
    // Edit phone otp operation data is missing or it is invalid
    SessionErrorKey["INVALID_EDIT_PHONE_OTP_OPERATION"] = "SessionErrorInvalidEditPhoneOtpOperation";
    // Edit email otp operation data is missing or it is invalid
    SessionErrorKey["INVALID_EDIT_EMAIL_OTP_OPERATION"] = "SessionErrorInvalidEditEmailOtpOperation";
    // Code token for the requested OTP operation is invalid
    SessionErrorKey["INVALID_OTP_TOKEN"] = "SessionErrorInvalidOtpToken";
    // Code for the requested OTP operation expired
    SessionErrorKey["OTP_CODE_EXPIRED"] = "SessionErrorExpiredOtpToken";
    SessionErrorKey["UNKNOWN"] = "SessionErrorUnknown";
    SessionErrorKey["INVALID_TOKEN_EXCHANGE_PARAMETERS"] = "SessionErrorInvalidTokenExchangeParameters";
    // Used to be thrown when an user attempts to login with a phone number or email that was not associated with an account
    SessionErrorKey["NO_ACCOUNT_ASSOCIATED"] = "SessionErrorNoAccountAssociated";
    // User is disabled
    SessionErrorKey["USER_DISABLED"] = "SessionErrorUserDisabled";
    //Used to be thrown when a user attempts to sign up with a phone number or email that is already in use
    SessionErrorKey["ACCOUNT_ALREADY_REGISTERED"] = "SessionErrorAlreadyRegistered";
    // Used when sending the OTP by SMS/Voice/Email faled
    SessionErrorKey["CODE_SEND_FAILED"] = "SessionErrorCodeSendFailed";
    // Invalid auth method has been provided
    SessionErrorKey["LOGIN_TYPE_DENIED"] = "SessionErrorLoginTypeDenied";
})(SessionErrorKey || (SessionErrorKey = {}));
export const managedRefreshErrors = [
    SessionErrorKey.ACCESS_DENIED,
    SessionErrorKey.AUTH_REQUIRED,
    SessionErrorKey.INPUT,
    SessionErrorKey.GONE,
    SessionErrorKey.MALFORMED_JWT,
    SessionErrorKey.MALFORMED_RESPONSE,
    SessionErrorKey.REFRESH_TOKEN_MISSING,
    SessionErrorKey.PUBLIC_KEY_MISSING,
    SessionErrorKey.REFRESH_AFTER_UPDATE_ERROR,
    SessionErrorKey.EXTERNAL_CALLBACK_ERROR,
    SessionErrorKey.USER_DISABLED,
];
/**
 * Custom error type that retains more information than the standard Error type.
 */
export class SessionError extends Error {
    constructor(message, data) {
        // TypeScript error ignored because we're simply on a older
        // TypeScript version that doesn't have `Error.cause` in
        // the lib definition yet.
        // @ts-expect-error TS2554 Expected 0-1 arguments, but got 2.
        super(message, { cause: data.cause });
        Object.setPrototypeOf(this, SessionError.prototype);
        // Set these as non-enumerable properties so that
        // Sentry doesn't extract them twice, once as
        // part of `.toJSON()` and once by enumerating
        // the properties using `Object.keys()`.
        Object.defineProperty(this, 'name', {
            enumerable: false,
            writable: false,
            value: data.name,
        });
        Object.defineProperty(this, 'source', {
            enumerable: false,
            // Writeable on purpose. Couple of places in the code
            // where this is assigned higher in the stack before
            // being re-thrown.
            writable: true,
            value: data.source || null,
        });
        Object.defineProperty(this, 'extra', {
            enumerable: false,
            writable: false,
            value: data.extra || {},
        });
        // Hack because Jest doesn't enumerate the error property
        // by default.
        // We only need it in the test. In the real world, this
        // is a real property: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (process.env.JEST_WORKER_ID) {
            this.cause = data.cause;
        }
    }
    toJSON() {
        return Object.assign({ name: this.name, source: this.source }, this.extra);
    }
}
/**
 * Custom error used only for HTTP-related errors that
 * carries a typed set of fields containing data about
 * the HTTP request/response that failed.
 *
 * Note that the format we export in `toJSON()` for logging
 * purposes differs from what we use in `.extra`.
 *
 * We do this because we want to provide backwards
 * compatibility for the field names historically
 * used in `.extra`. Our applications consume these
 * fields and we cannot just rename them without
 * breaking them.
 *
 * In order to prevent polluting the logs, the
 * field names are transformed in `.toJSON()`.
 */
export class SessionHTTPError extends SessionError {
    constructor(message, data) {
        super(message, data);
        Object.setPrototypeOf(this, SessionHTTPError.prototype);
    }
    toJSON() {
        // Translate these into more generic keys in order
        // to avoid polluting the logs with these custom
        // fields that we cannot rename without breaking
        // consumers of this library.
        const _a = this.extra, { httpRequestURL, httpRequestAccept, httpRequestAcceptLanguage, httpResponseContentType, httpResponseStatus, httpResponseBody, httpResponseWwwAuthenticateHeader } = _a, extra = __rest(_a, ["httpRequestURL", "httpRequestAccept", "httpRequestAcceptLanguage", "httpResponseContentType", "httpResponseStatus", "httpResponseBody", "httpResponseWwwAuthenticateHeader"]);
        const context = Object.assign({ name: this.name, source: this.source }, extra);
        if (httpRequestURL) {
            context.url = httpRequestURL;
        }
        const requestHeaders = [];
        if (httpRequestAccept) {
            requestHeaders.push(['accept', httpRequestAccept]);
        }
        if (httpRequestAcceptLanguage) {
            requestHeaders.push(['accept-language', httpRequestAcceptLanguage]);
        }
        if (requestHeaders.length) {
            context.options = this.stringify({
                headers: requestHeaders,
            });
        }
        if (httpResponseStatus) {
            context.status = httpResponseStatus;
        }
        if (httpResponseBody) {
            context.data = this.stringify(httpResponseBody);
        }
        const responseHeaders = [];
        if (httpResponseContentType) {
            responseHeaders.push(['content-type', httpResponseContentType]);
        }
        if (httpResponseWwwAuthenticateHeader) {
            responseHeaders.push(['www-authenticate', httpResponseWwwAuthenticateHeader]);
        }
        if (responseHeaders.length) {
            context.headers = responseHeaders;
        }
        return context;
    }
    stringify(data) {
        if (!data) {
            return data;
        }
        if (typeof data === 'string') {
            return data;
        }
        try {
            return '#' + JSON.stringify(data);
        }
        catch (_e) {
            return String(data);
        }
    }
}
